import { render, staticRenderFns } from "./ClipperExportMessage.vue?vue&type=template&id=381ff23a&scoped=true&"
import script from "./ClipperExportMessage.vue?vue&type=script&lang=js&"
export * from "./ClipperExportMessage.vue?vue&type=script&lang=js&"
import style0 from "./ClipperExportMessage.vue?vue&type=style&index=0&id=381ff23a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ff23a",
  null
  
)

export default component.exports